module.exports = __webpack_public_path__ + "img/PRCA1_DC.45e142d1.png";